import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import ArrowBackSharpIcon from "@material-ui/icons/ArrowBackSharp";
import { makeStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles(() => ({
  back: { marginBottom: 20 },
  title: { paddingTop: 8, paddingLeft: 10 },
}));

function SectionHead(props) {
  const classes = useStyles();
  const { name, back } = props;
  return (
    <>
      <Grid container direction="row">
        <Grid item>
          <IconButton aria-label="back" className={classes.back} onClick={back}>
            <ArrowBackSharpIcon fontSize="medium" />
          </IconButton>
        </Grid>
        <Grid item>
          <Typography variant="h5" color="primary" className={classes.title}>
            {name}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}

SectionHead.propTypes = {
  name: PropTypes.any,
  back: PropTypes.any,
};

export default SectionHead;
